import { commonMutationTypes } from "../../../../../../../../utils/commonQueryTypes";

export interface UpdateJunctionPriorityResult {
  UpdateJunctionPriority: boolean;
}

export enum PriorityType{
  CRITICAL = "CRITICAL",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export interface UpdateJunctionPriorityVar extends commonMutationTypes {
  junctionIds: number[];
  priority: PriorityType;
}
